'use client';

import { getLanguageFromLocale } from '@bomdisoft/translations';
import s from '@pieleaf/app/[lang]/home/sections/how-it-works/styles.module.css';
import { howOrderingWorksTitle, noAccountNeeded, stepBrowseBody, stepBrowseTitle, stepPayBody, stepPayTitle, stepSelectBody, stepSelectTitle, stepTrackBody, stepTrackTitle } from '@pieleaf/translations';
import { useParams } from 'next/navigation';

export const HowItWorksSection = () => {
  const params = useParams();
  const language = getLanguageFromLocale(typeof params.lang === 'string' ? params.lang : 'en');

  const steps = [
    { body: stepBrowseBody, testId: 'step-browse', title: stepBrowseTitle },
    { body: stepSelectBody, testId: 'step-select', title: stepSelectTitle },
    { body: stepPayBody, testId: 'step-pay', title: stepPayTitle },
    { body: stepTrackBody, testId: 'step-track', title: stepTrackTitle },
  ];

  return (
    <section className={s.section} data-testid='how-it-works-section'>
      <div className={s.inner}>
        <div className={s.head}>
          <h2 className={s.heading}>{howOrderingWorksTitle[language]}</h2>
          <span className={s.note}>{noAccountNeeded[language]}</span>
        </div>

        <ol className={s.rail}>
          {steps.map((step, index) => (
            <li className={s.node} data-testid={step.testId} key={step.testId}>
              <span className={s.numeral}>{index + 1}</span>
              <h3 className={s.stepTitle}>{step.title[language]}</h3>
              <p className={s.stepBody}>{step.body[language]}</p>
            </li>
          ))}
        </ol>
      </div>
    </section>
  );
};
